// extracted by mini-css-extract-plugin
export default {"carDesignContainer":"CarDesign_carDesignContainer__sf7VP"};